export default __webpack_public_path__ + "static/media/Formular-Medium.81ff6367.svg";